import React from "react";

export default function Impressum() {
  const currentYear = new Date().getFullYear();

  return (
    <div style={{
      padding: "3rem 2rem",
      maxWidth: "900px",
      margin: "0 auto",
      lineHeight: "1.6",
      fontFamily: "'Inter', Arial, sans-serif",
      color: "#222"
    }}>
      <header style={{ borderBottom: "3px solid #d44", marginBottom: "2rem" }}>
        <div className="pt-6" />

        <h1 style={{ fontSize: "2rem", marginBottom: "0.5rem" }}>Impressum</h1>
        <p style={{ color: "#666", marginBottom: "1rem" }}>
          Angaben gemäß § 5 TMG und Verantwortlicher für den Inhalt nach § 55 Abs. 2 RStV
        </p>
      </header>

      {/* --- Abschnitt: Anschrift --- */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ color: "#d44", fontSize: "1.4rem" }}>Anschrift</h2>
        <p>
          <strong>Dr.-Ing. Eike Radeisen – Erdwärme-Experten</strong><br />
          {/* Bitte echte Anschrift einfügen */}
          Brahmsstraße 1<br />
          14193 Berlin<br />
          Deutschland
        </p>
        <p>

          E-Mail: <a href="mailto:info@erdwaerme-experten.de">info@erdwaerme-experten.de</a><br />
          Website: <a href="https://www.erdwaerme-experten.de">www.erdwaerme-experten.de</a>
        </p>

        <p>
          Rechtsform: Einzelunternehmer<br />
          Umsatzsteuerbefreit gemäß § 19 UStG (Kleinunternehmerregelung)<br />
          Keine Eintragung im Handelsregister
        </p>
      </section>

      {/* --- Abschnitt: Haftungsausschluss --- */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ color: "#d44", fontSize: "1.4rem" }}>Haftungsausschluss</h2>
        <p>
          Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Für die Richtigkeit,
          Vollständigkeit und Aktualität der Inhalte übernehmen wir jedoch keine Gewähr. Als
          Diensteanbieter sind wir gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach
          den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als
          Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
          Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige
          Tätigkeit hinweisen.
        </p>
        <p>
          Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den
          allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch
          erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei
          Bekanntwerden entsprechender Rechtsverletzungen werden wir diese Inhalte umgehend
          entfernen.
        </p>
      </section>

      {/* --- Abschnitt: Haftung für Links --- */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ color: "#d44", fontSize: "1.4rem" }}>Haftung für Links</h2>
        <p>
          Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen
          Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr
          übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder
          Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der
          Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum
          Zeitpunkt der Verlinkung nicht erkennbar.
        </p>
        <p>
          Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete
          Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von
          Rechtsverletzungen werden wir derartige Links umgehend entfernen.
        </p>
      </section>

      {/* --- Abschnitt: Urheberrecht --- */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ color: "#d44", fontSize: "1.4rem" }}>Urheberrecht</h2>
        <p>
          Die durch den Betreiber dieser Website erstellten Inhalte und Werke unterliegen dem
          deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
          Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen
          Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind
          nur für den privaten, nicht kommerziellen Gebrauch gestattet.
        </p>
        <p>
          Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die
          Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche
          gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden,
          bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen
          werden wir derartige Inhalte umgehend entfernen.
        </p>
      </section>

      {/* --- Footer --- */}
      <footer style={{ borderTop: "1px solid #ddd", paddingTop: "1rem", color: "#555" }}>
        <p>© {currentYear} Dr.-Ing. Eike Radeisen – Erdwärme-Experten. Alle Rechte vorbehalten.</p>
      </footer>
    </div>
  );
}
